<template>
  <div class="media-preview floating-modal">
    <div class="media-container">
      <div class="w-100 h-100 overflow-auto">
        <div
          class="
            lead
            text-center
            pt-3
            pb-5
            px-3
            text-uppercase
            fw-bold
            position-relative
          "
        >
          Add Material
          <button
            class="btn-close btn-close-white btn-close-small"
            @click="close"
          >
            &times;
          </button>
        </div>
        <div>
          <div class="mb-3">
            <label for="material" class="form-label">Material</label>
            <select class="form-select" id="material" @input="materialSelected">
              <option disabled>-- Select a material</option>
              <option
                v-for="material in materials"
                :key="material._id"
                :value="JSON.stringify(material)"
              >
                {{ material.itemCode }} - {{ material.description }}
              </option>
            </select>
          </div>
          <div class="row" v-if="models.itemCode">
            <div class="col-6">
              <div class="mb-3">
                <label for="unit" class="form-label">Unit</label>
                <input
                  type="text"
                  class="form-control"
                  id="unit"
                  v-model="models.unit"
                  readonly
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="sor" class="form-label">S.O.R</label>
                <input
                  type="text"
                  class="form-control"
                  id="sor"
                  v-model="models.sor"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="rate" class="form-label">Rate (RM)</label>
                <input
                  type="number"
                  class="form-control"
                  id="rate"
                  v-model="models.rate"
                  @change="itemChange()"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="quantity" class="form-label">Quantity</label>
                <input
                  type="number"
                  class="form-control"
                  id="quantity"
                  v-model="models.quantity"
                  @change="itemChange()"
                />
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="amount" class="form-label">Amount (RM)</label>
                <input
                  type="text"
                  class="form-control"
                  id="amount"
                  v-model="models.amount"
                  readonly
                />
              </div>
            </div>
          </div>
        </div>
        <div class="text-center p-3">
          <button class="btn btn-secondary me-3" @click="close">Cancel</button>
          <button class="btn btn-primary ms-3" @click="save">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "material-selector",
  props: ["bqId"],
  data() {
    return {
      materials: [],
      models: {
        itemCode: null,
        sor: null,
        description: null,
        unit: null,
        rate: 0,
        amount: 0,
        quantity: 0,
      },
      defaultModels: {
        itemCode: null,
        sor: null,
        description: null,
        unit: null,
        rate: 0,
        amount: 0,
        quantity: 0,
      },
    };
  },
  methods: {
    itemChange() {
      this.models.rate = parseFloat(this.models.rate);
      this.models.quantity = parseFloat(this.models.quantity);

      this.models.amount = (this.models.rate * this.models.quantity).toFixed(2);
    },
    triggerAlert(icon, text, callback, callbackData) {
      Swal.fire({
        icon: icon,
        title: `<h5>${text}</h5>`,
      }).then(() => {
        if (callback) {
          this.$emit(callback, callbackData);
        }
      });
    },
    async getAllMaterials() {
      const [call, error] = await this.Helper.handlePromise(
        this.API.get(`nod-materials`)
      );

      if (error) {
        this.triggerAlert("error", "Error getting site visit data");
      } else {
        this.materials = call.data;
      }
    },
    materialSelected(e) {
      const value = JSON.parse(e.target.value);

      Object.keys(this.models).forEach((key) => {
        this.models[key] = value[key] || this.defaultModels[key];
      });
    },
    save() {
      if (!this.models.itemCode) {
        Swal.fire("", "Please select a material", "warning");
      } else if (
        Object.keys(this.models).some((key) => this.models[key] === null)
      ) {
        Swal.fire("", "Please fill all fields", "warning");
      } else {
        this.itemChange();
      }
    },
    close() {
      this.$emit("close");
    },
  },
  mounted() {
    Object.keys(this.defaultModels).forEach((key) => {
      this.models[key] = this.defaultModels[key];
    });

    this.getAllMaterials();
  },
};
</script>